import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const productReportApi = (id) =>
    Promise.resolve(axios.get(endpoints.productReport.replace("{id}", id)));
